<template>
  <section v-if="!isMobile" class="word-grexy">
    <b-container>
      <b-row>
        <b-col sm="12" md="12" lg="12">
          <div class="word-grexy-container">
            <h3 class="title">{{$t('word_grexy_title')}}</h3>
            <p class="subtitle">{{$t('word_grexy_subtitle')}}</p>
            <div class="for-users-card-box">
              <h3 class="title">{{$t('word_grexy_title_for')}}</h3>
              <b-row>
                <b-col sm="12" md="4" lg="4">
                  <div class="card-box">
                    <img class="icon" src="../assets/img/new-content/dog-walk-icon.svg" alt="Dog walk">
                    <h5 class="title-card">{{$t('key1_title')}}</h5>
                    <p class="subtitle-card">{{$t('key1_text')}}</p>
                  </div>
                </b-col>
                <b-col sm="12" md="4" lg="4">
                  <div class="card-box">
                    <img class="icon" src="../assets/img/new-content/Registration-icon.svg" alt="Registration">
                    <h5 class="title-card">{{$t('key2_title')}}</h5>
                    <p class="subtitle-card">{{$t('key2_text')}}</p>
                  </div>
                </b-col>
                <b-col sm="12" md="4" lg="4">
                  <div class="card-box">
                    <img class="icon" src="../assets/img/new-content/Business.svg" alt="Business">
                    <h5 class="title-card">{{$t('key3_title')}}</h5>
                    <p class="subtitle-card">{{$t('key3_text')}}</p>
                  </div>
                </b-col>
              </b-row>
            </div>
            <div class="btn-shop-action">
              <a class="btn-shop" href="https://apps.apple.com/ua/app/grexy/id6470862283?l=uk" target="_blank"><img class="subscribe-icon" src="../assets/img/long-btn-appstore.png" alt="Registration image"></a>
              <a class="btn-shop" href="https://play.google.com/store/apps/details?id=com.grexy" target="_blank"><img class="subscribe-icon" src="../assets/img/long-btn-googleplay.png" alt="Registration image"></a>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </section>
</template>

<script>
export default {
  data () {
    return {
      isMobile: false
    }
  },
  mounted () {
    this.isMobile = this.$isMobile()
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/sass/app.scss";
.word-grexy{
  padding: 120px 0 56px 0;
  background: #ffffff;
  @media screen and (min-width: 320px) {
    padding: 80px 0 56px 0;
  }
  @media screen and (min-width: 374px) {
  }
  @media screen and (min-width: 425px) {
  }
  @media screen and (min-width: 768px) {
    padding: 120px 0 56px 0;
  }
  @media screen and (min-width: 992px) {
  }
  @media screen and (min-width: 1440px) {
  }
  @media screen and (min-width: 1920px) {
  }
  .word-grexy-container{
    width: 100%;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 56px;
    font-family: $main-font;
    @media screen and (min-width: 320px) {
      gap: 30px;
    }
    @media screen and (min-width: 374px) {
      gap: 40px;
    }
    @media screen and (min-width: 425px) {
    }
    @media screen and (min-width: 768px) {
      gap: 56px;
    }
    @media screen and (min-width: 992px) {
    }
    @media screen and (min-width: 1440px) {
    }
    @media screen and (min-width: 1920px) {
    }
    .title{
      font-size: 40px;
      font-weight: 700;
      line-height: 48px;
      text-align: center;
      color: #30394B;
      margin: 0;
      @media screen and (min-width: 320px) {
        font-size: 32px;
        font-weight: 700;
        line-height: 38.4px;
      }
      @media screen and (min-width: 374px) {
      }
      @media screen and (min-width: 425px) {
      }
      @media screen and (min-width: 768px) {
        font-size: 40px;
        font-weight: 700;
        line-height: 48px;
      }
      @media screen and (min-width: 992px) {
      }
      @media screen and (min-width: 1440px) {
      }
      @media screen and (min-width: 1920px) {
      }
    }
    .subtitle{
      font-size: 32px;
      font-weight: 500;
      line-height: 48px;
      text-align: center;
      color: #7A7CE8;
      margin: 0;
      @media screen and (min-width: 320px) {
        font-size: 20px;
        font-weight: 500;
        line-height: 28px;
      }
      @media screen and (min-width: 374px) {
      }
      @media screen and (min-width: 425px) {
      }
      @media screen and (min-width: 768px) {
        font-size: 32px;
        font-weight: 500;
        line-height: 48px;
      }
      @media screen and (min-width: 992px) {
      }
      @media screen and (min-width: 1440px) {
      }
      @media screen and (min-width: 1920px) {
      }
    }
    .for-users-card-box{
      width: 100%;
      .title{
        margin-bottom: 56px;
      }
      .card-box{
        height: 100%;
        box-shadow: 0px 6px 16px 0px #30394B2E;
        border-radius: 24px;
        padding: 24px;
        .icon{
          width: 104px;
          height: 104px;
          margin-bottom: 24px;
        }
        .title-card{
          font-family: $main-font;
          font-size: 20px;
          font-weight: 700;
          line-height: 24px;
          text-align: left;
          margin: 0 0 9px 0;
        }
        .subtitle-card{
          font-family: $main-font;
          font-size: 14px;
          font-weight: 300;
          line-height: 21px;
          text-align: left;
          margin: 0;
        }
      }
    }
    .btn-shop-action{
      display: flex;
      justify-content: flex-start;
      align-items: center;
      gap: 16px;
      .btn-shop{
        width: 100%;
        max-width: 189px;
        background: transparent;
        padding: 0;
        height: 56px;
        border: none;
        &:hover{

          img{
            transition: transform .5s;
            transform: scale(1.02);
          }
        }
        img{
          transition: transform .5s;
          width: 100%;
          height: auto;
        }
      }
    }
  }
}
</style>
